import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [
    "huntressOrganizationMapping",
    "mappedOrganizationsDatatable",
    "unmappedOrganizationsDatatable",
    "form",
    "submitButton"
  ]

  static values = {
    initialMappings: { type: Object, default: { mapped: [], unmapped: [] } },
    curriculaAccountsById: { type: Object, default: {} },
    optionsPath: String,
  }

  connect() {
    this.huntressOrganizationMappingTargets.forEach(target => {
      $(target).select2({
        placeholder: "Select an option...",
        allowClear: true,
        include_blank: true,
        theme: "bootstrap",
        width: "100%",
        ajax: {
          url: this.optionsPathValue,
          type: "POST",
          dataType: "json",
          data: this.select2AjaxData.bind(this),
          delay: 150,
        }
      })
        .on("select2:select", this.handleMappedSelect.bind(this))
    })

    const datatableOptions = {
      searching: true,
      columnDefs: [{ searchable: false, targets: 1 }],
    }
    this.mappedDatatable = $(this.mappedOrganizationsDatatableTarget).dataTable(datatableOptions)
    this.unmappedDatatable = $(this.unmappedOrganizationsDatatableTarget).dataTable(datatableOptions)

    this.setInitialMappings()
  }

  select2AjaxData(params) {
    const mappingValues = Object.values(this.updatedMappings)
    const disabledCurriculaIds = mappingValues.map(mapping => mapping.curricula_id).filter(n => n)

    return {
      term: params.term,
      page: params.page,
      disabled_curricula_ids: disabledCurriculaIds
    }
  }

  setInitialMappings() {
    this.initialMappings = {}
    this.updatedMappings = {}
    this.touchedOrgIds = new Set()

    const { mapped, unmapped } = this.initialMappingsValue

    const callback = organization => {
      this.initialMappings[organization.id] = Object.assign({}, organization)
      this.updatedMappings[organization.id] = Object.assign({}, organization)
    }
    mapped.forEach(callback)
    unmapped.forEach(callback)
  }

  handleMappedSelect(e) {
    const { dataset, value } = e.target

    if (value === "__create_new__") {
      this.updatedMappings[dataset.organizationId] = {
        curricula_id: "__create_new__",
        curricula_name: null,
        active_learner_count: 0,
      }
    } else {
      this.updatedMappings[dataset.organizationId] = this.curriculaAccountsByIdValue[value]
    }
    this.touchedOrgIds.add(dataset.organizationId)
    this.toggleButtonDisable()
  }

  toggleButtonDisable() {
    const disable = Object.keys(this.initialMappings).every(organizationId => {
      return this.initialMappings[organizationId] === this.updatedMappings[organizationId]
    })

    this.submitButtonTarget.disabled = disable
  }

  handleSubmit(e) {
    this.appendValuesToForm()
  }

  appendValuesToForm() {
    // Disable untouched selects so they don't submit stale/empty values
    this.huntressOrganizationMappingTargets.forEach(target => {
      if (!this.touchedOrgIds.has(target.dataset.organizationId)) {
        target.disabled = true
      }
    })

    this.touchedOrgIds.forEach(orgId => {
      const curriculaId = this.updatedMappings[orgId].curricula_id
      const mapping = this.curriculaAccountsByIdValue[curriculaId]

      const curriculaIdInput = document.createElement("input")
      curriculaIdInput.type = "hidden"
      curriculaIdInput.name = `organization_mapping[${orgId}][curricula_id]`
      curriculaIdInput.value = curriculaId || ""

      const curriculaNameInput = document.createElement("input")
      curriculaNameInput.type = "hidden"
      curriculaNameInput.name = `organization_mapping[${orgId}][curricula_name]`
      curriculaNameInput.value = mapping?.curricula_name || ""

      const learnerCountInput = document.createElement("input")
      learnerCountInput.type = "hidden"
      learnerCountInput.name = `organization_mapping[${orgId}][active_learner_count]`
      learnerCountInput.value = mapping?.active_learner_count || ""

      this.formTarget.append(curriculaIdInput)
      this.formTarget.append(curriculaNameInput)
      this.formTarget.append(learnerCountInput)
    })
  }
}
